import { useState } from 'react';
import { DeleteCounterConfirmationDialog } from './CounterForm/DeleteCounterConfirmationDialog';
import { CounterFormCloseConfirmationDialog } from './CounterForm/CounterFormCloseConfirmationDialog';
import { CounterFormSetAsDefaultConfirmationDialog } from './CounterForm/CounterFormSetAsDefaultConfirmationDialog';

interface Props {
    submit: () => Promise<void>;
    closeAction: () => void;
    handleDelete: () => Promise<void>;
    onSubmitAttempt: () => Promise<void>;
}

export const useConfirmDialogs = ({ submit, closeAction, onSubmitAttempt, handleDelete }: Props) => {
    const [isDeleteConfirmationOpen, setIsDeleteConfirmationOpen] = useState(false);
    const [isCloseConfirmationOpen, setIsCloseConfirmationOpen] = useState(false);
    const [isSetDefaultConfirmationOpen, setIsSetDefaultConfirmationOpen] = useState(false);

    const handleClose = () => {
        setIsSetDefaultConfirmationOpen(false);
        setIsDeleteConfirmationOpen(false);
        setIsCloseConfirmationOpen(false);
        closeAction();
    };

    return {
        Dialogs: (
            <>
                <DeleteCounterConfirmationDialog
                    onSubmit={async () => {
                        await handleDelete();
                        handleClose();
                    }}
                    onCancel={() => setIsDeleteConfirmationOpen(false)}
                    isOpen={isDeleteConfirmationOpen}
                />
                <CounterFormCloseConfirmationDialog
                    onSubmit={onSubmitAttempt}
                    onCancel={handleClose}
                    isOpen={isCloseConfirmationOpen}
                />
                <CounterFormSetAsDefaultConfirmationDialog
                    onSubmit={async () => {
                        await submit();
                        handleClose();
                    }}
                    onCancel={() => setIsSetDefaultConfirmationOpen(false)}
                    isOpen={isSetDefaultConfirmationOpen}
                />
            </>
        ),
        setIsDeleteConfirmationOpen,
        setIsSetDefaultConfirmationOpen,
        setIsCloseConfirmationOpen,
    };
};
